export default "__VITE_ASSET__D4$8iQ43__"